import { useQuery } from '@tanstack/react-query';
import { ApiHandler } from '../handlers';
import { DonationStatistic } from '../models';

const zeroDonationsLifetimeStatistics: DonationStatistic = {
    sum: 0,
    netSum: 0,
    count: 0,
    donorsCount: 0,
    average: 0,
};

export const useDonationsLifetimeStatisticsQuery = (doneeId: number) => {
    const query = useQuery({
        queryKey: [
            ApiHandler.instance.donees.getDonationsLifetimeStatistics.name,
            doneeId,
        ],
        queryFn: async () => {
            const result =
                await ApiHandler.instance.donees.getDonationsLifetimeStatistics(
                    doneeId,
                );
            if (!result.success) {
                throw result.error;
            }
            return result.response.data;
        },
        enabled: !!doneeId,
        staleTime: Infinity,
    });

    return {
        ...query,
        data: query.data ?? zeroDonationsLifetimeStatistics,
    };
};
